import { createSlice } from "@reduxjs/toolkit";
import { DonerInitialLoad, DonerPaggination } from "../thunk/DonnerThunk";



const initialState = {
    doners: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};


export const DonerSlice = createSlice({
    name: "doners",
    initialState,
    reducers: {
        resetDoner: (state, action) => {
            return {
                ...initialState
            };

        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(DonerInitialLoad.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(DonerInitialLoad.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    doners: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(DonerInitialLoad.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            })
            .addCase(DonerPaggination.pending, (state, action) => {
                return { ...state, showLoading: true };
            })
            .addCase(DonerPaggination.fulfilled, (state, action) => {

                // console.log({ action });

                return {
                    ...state,
                    doners: action.payload,
                    errorMessage: '',
                    successMessage: '',
                    showLoading: false,
                };
            })
            .addCase(DonerPaggination.rejected, (state, action) => {
                let errorMessage;
                if (action.payload) {
                    // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, the payload will be available here.
                    errorMessage = action.payload;
                } else {
                    errorMessage = action.error.message?.toString();
                }

                return { ...state, errorMessage, showLoading: false }
            });
    },
});


export const { resetDoner } = DonerSlice.actions;

export const DonerReducer = DonerSlice.reducer;